module.exports = __webpack_public_path__ + "static/media/logo.c0b8a6eb.png";